const NS = 'RestrictTo'; // jshint ignore:line

export default function RestrictTo() {
  "ngInject";

  return {
    restrict: 'A',
    link: function (scope: any, element: any, attrs: any) {
      const regEx : RegExp = RegExp(attrs.restrictTo);
      const excludedKeys : RegExp = /Backspace|Enter|Tab|Delete|Del|ArrowUp|Up|ArrowDown|Down|ArrowLeft|Left|ArrowRight|Right/;

      element[0].addEventListener('keydown', (event: KeyboardEvent) => {
        if (!excludedKeys.test(event.key))
        {
          const elementValue: string = element[0].value;

          if (!regEx.test(event.key) || !regEx.test(elementValue)) {
            event.preventDefault();
          }
        }
      });
    }
  }
}
